import { ValueOfKey } from '../../../utils-types';

export const SCHOLASTIC_CUSTOMER_COLUMN = {
  NAME: 'NAME',
  LOCATION: 'LOCATION',
  AFFILIATE: 'AFFILIATE',
  COACH: 'COACH',
  START_DATE: 'START_DATE',
  STATUS: 'STATUS',
  CUSTOM_FILTER: 'CUSTOM_FILTER',
  ACTIONS: 'ACTIONS',
} as const;

export type ScholasticCustomerColumn = ValueOfKey<typeof SCHOLASTIC_CUSTOMER_COLUMN>;

export type ShowColumnsConfig = Record<ScholasticCustomerColumn, boolean>;

export const COLUMN_WIDTHS: Record<ScholasticCustomerColumn, string> = {
  NAME: '250px',
  LOCATION: '1fr',
  AFFILIATE: '1fr',
  COACH: '1fr',
  START_DATE: '1fr',
  STATUS: '1fr',
  CUSTOM_FILTER: '1fr',
  ACTIONS: 'auto',
};
